import { BaseItem } from './baseItem'
import {SelectedValue} from './selectedValue'
import {ImageMeta} from './imageMeta'
import {AreaOfDamageImage} from './areaOfDamageImage'
/**
 * Class representing a baggage item
 */
export class BaggageItem extends BaseItem {
  /**
     * Create a baggage item.
     * @param {object} options - the baggage item's  options to construct the baggage item object
     * @param {String} tagNumber - the tag number
     * @param {SelectedValue} height - height of the item
     * @param {SelectedValue} options.brand - id of the selected brand
     * @param {SelectedValue} options.type - id of the selected type
     * @param {SelectedValue} options.colour - id of the selected colour
     * @param {SelectedValue} options.material - id of the selected material
     * @param {SelectedValue} options.lock - id of the selected lock
     * @param {SelectedValue} options.wheel - id of the selected wheel
     * @param {SelectedValue} options.damageType - id of the selected damage type
     * @param {ImageMeta} options.wholeCaseImage
     * @param {ImageMeta} options.badgeImage - cases badge image
     * @param {ImageMeta} options.baggageTagImage - image of baggage tag
     * @param {Number} options.replacementVariantId - id of the selected replacement for the item
     * @param {Number} options.replacementColorId - id of the selected replacement for the item
     * @param {Number} options.replacementAltColorIds - list of ids of the selected alternative
     * replacement colours for the item
     * @param {Boolean} options.replacementChosen - have the user did the decision on replacmements
     * @param {Boolean} options.isExpandable - is the baggage expandable
     * @param {String} options.baggageModel - the user entered baggageModel. Only used for buggyTypes
     * @param {String} options.serialNumber - the user entered serial number. Only used for buggyTypes
     */
  constructor (options) {
    if (options) {
      super(options.purchaseDate,
        options.areaOfDamageImages,
        options.receipt,
        options.price)
      this.tagNumber = options.tagNumber
      this.height = options.height
      this.brand = options.brand
      this.type = options.type
      this.colour = options.colour
      this.material = options.material
      this.lock = options.lock
      this.wheel = options.wheel
      this.damageType = options.damageType
      this.wholeCaseImage = options.wholeCaseImage
      this.badgeImage = options.badgeImage
      this.baggageTagImage = options.baggageTagImage
      this.replacementVariantId = options.replacementVariantId
      this.replacementColorId = options.replacementColorId
      this.replacementAltColorIds = options.replacementAltColorIds
      this.replacementChosen = options.replacementChosen
      this.isExpandable = options.isExpandable
      this.baggageModel = options.baggageModel
      this.serialNumber = options.serialNumber
    } else {
      super()
    }
  }

  get tagNumber () {
    return this._tagNumber
  }

  set tagNumber (value) {
    if (value) this._tagNumber = String(value)
    else this._tagNumber = null
  }

  get baggageModel () {
    return this._baggageModel
  }

  set baggageModel (value) {
    if (value) this._baggageModel = String(value)
    else this._baggageModel = null
  }

  get serialNumber () {
    return this._serialNumber
  }

  set serialNumber (value) {
    if (value) this._serialNumber = String(value)
    else this._serialNumber = null
  }

  get brand () {
    return this._brand
  }

  set brand (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('brand is not an instance of SelectedValue')
    }
    this._brand = value
  }

  get type () {
    return this._type
  }

  set type (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('type is not an instance of SelectedValue')
    }
    this._type = value
  }

  get colour () {
    return this._colour
  }

  set colour (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('colour is not an instance of SelectedValue')
    }
    this._colour = value
  }

  get height () {
    return this._height
  }

  set height (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('height is not an instance of SelectedValue')
    }
    this._height = value
  }

  get material () {
    return this._material
  }

  set material (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('material is not an instance of SelectedValue')
    }
    this._material = value
  }

  get lock () {
    return this._lock
  }

  set lock (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('lock is not an instance of SelectedValue')
    }
    this._lock = value
  }

  get wheel () {
    return this._wheel
  }

  set wheel (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('wheel is not an instance of SelectedValue')
    }
    this._wheel = value
  }

  get damageType () {
    return this._damageType
  }

  set damageType (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('damageType is not an instance of SelectedValue')
    }
    this._damageType = value
  }

  get wholeCaseImage () {
    return this._wholeCaseImage
  }

  set wholeCaseImage (value) {
    if (value && !(value instanceof ImageMeta)) {
      throw new TypeError('wholeCaseImage is not an instance of ImageMeta')
    }
    this._wholeCaseImage = value
  }

  get badgeImage () {
    return this._badgeImage
  }

  set badgeImage (value) {
    if (value && !(value instanceof ImageMeta)) {
      throw new TypeError('badgeImage is not an instance of ImageMeta')
    }
    this._badgeImage = value
  }

  get baggageTagImage () {
    return this._baggageTagImage
  }

  set baggageTagImage (value) {
    if (value && !(value instanceof ImageMeta)) {
      throw new TypeError('baggageTagImage is not an instance of ImageMeta')
    }
    this._baggageTagImage = value
  }

  get replacementVariantId () {
    return this._replacementVariantId
  }

  set replacementVariantId (value) {
    if (value) this._replacementVariantId = Number(value)
    else this._replacementVariantId = null
  }

  get replacementColorId () {
    return this._replacementColorId
  }

  set replacementColorId (value) {
    if (value) this._replacementColorId = Number(value)
    else this._replacementColorId = null
  }

  get replacementAltColorIds () {
    return this._replacementAltColorIds
  }

  set replacementAltColorIds (value) {
    if (value) this._replacementAltColorIds = value
    else this._replacementAltColorIds = null
  }

  get replacementChosen () {
    return this._replacementChosen
  }

  set replacementChosen (value) {
    if (value) this._replacementChosen = Boolean(value)
    else this._replacementChosen = false
  }

  get isExpandable () {
    return this._isExpandable
  }

  set isExpandable (value) {
    if (value) this._isExpandable = Boolean(value)
    else this._isExpandable = false
  }

  toJSON () {
    let json = super.toJSON()
    Object.assign(json, {
      tagNumber: this._tagNumber,
      height: this._height,
      brand: this._brand,
      type: this._type,
      colour: this._colour,
      material: this._material,
      lock: this._lock,
      wheel: this._wheel,
      damageType: this._damageType,
      wholeCaseImage: this._wholeCaseImage,
      badgeImage: this._badgeImage,
      baggageTagImage: this._baggageTagImage,
      replacementVariantId: this._replacementVariantId,
      replacementColorId: this._replacementColorId,
      replacementAltColorIds: this._replacementAltColorIds,
      isExpandable: this._isExpandable,
      baggageModel: this._baggageModel,
      serialNumber: this._serialNumber
    })
    return json
  }

  /**
   * Baggage item constructor (with flat options)
   * Takes flat options, converts them to suitable types
   * @param {Object} options - options for the baggage item
   */
  static BaggageItemFromFlat (options) {
    // Whole case image
    if (options.images.wholeCase && options.images.wholeCase.imageUrl) {
      options.wholeCaseImage = new ImageMeta({
        imageUrl: options.images.wholeCase.imageUrl
      })
    } else {
      options.wholeCaseImage = new ImageMeta({})
    }

    // Badge image
    if (options.images.badge && options.images.badge.imageUrl) {
      options.badgeImage = new ImageMeta({
        imageUrl: options.images.badge.imageUrl
      })
    } else {
      options.badgeImage = new ImageMeta({})
    }

    // Baggage tag image
    if (options.images.baggageTag && options.images.baggageTag.imageUrl) {
      options.baggageTagImage = new ImageMeta({
        imageUrl: options.images.baggageTag.imageUrl
      })
    } else {
      options.baggageTagImage = new ImageMeta({})
    }

    // Receipt image
    if (options.receipt && options.receipt.imageUrl) {
      options.receipt = new ImageMeta({
        imageUrl: options.receipt.imageUrl
      })
    } else {
      options.receipt = new ImageMeta({})
    }

    // Optional Height
    if (options.height) {
      options.height = new SelectedValue(options.height, options.heightString, options.additionalHeightInfo)
    }

    // Optional Wheels
    if (options.wheel) {
      options.wheel = new SelectedValue(options.wheel, options.wheelString, options.additionalWheelInfo)
    }

    // Optional material
    if (options.material) {
      options.material = new SelectedValue(options.material, options.materialString, options.additionalMaterialInfo)
    }

    // Optional locks
    if (options.lock) {
      options.lock = new SelectedValue(options.lock, options.lockString, options.additionalLockInfo)
    }

    // Optional damage type
    if (options.damageType) {
      options.damageType = new SelectedValue(options.damageType, options.damageTypeString, options.additionalDamageTypeInfo)
    }

    // Area of damage images
    options.areaOfDamageImages = convertToAreaOfDamageImages(options.areaOfDamageImages)

    return new BaggageItem({
      purchaseDate: options.purchaseDate,
      price: new SelectedValue(options.price, options.priceString, options.additionalPriceInfo),
      tagNumber: options.tagNumber,
      height: options.height,
      brand: new SelectedValue(options.brand, options.brandString, options.additionalBrandInfo),
      type: new SelectedValue(options.type, options.typeString),
      colour: new SelectedValue(options.colour, options.colourString),
      material: options.material,
      lock: options.lock,
      wheel: options.wheel,
      damageType: options.damageType,
      replacementVariantId: options.replacementVariantId,
      replacementColorId: options.replacementColorId,
      replacementAltColorIds: options.replacementAltColorIds,
      replacementChosen: options.replacementChosen,
      isExpandable: options.isExpandable,
      wholeCaseImage: options.wholeCaseImage,
      badgeImage: options.badgeImage,
      baggageTagImage: options.baggageTagImage,
      receipt: options.receipt,
      areaOfDamageImages: options.areaOfDamageImages,
      baggageModel: options.baggageModel,
      serialNumber: options.serialNumber
    })
  }
}

function convertToAreaOfDamageImages (areaOfDamageImages) {
  let images = []
  areaOfDamageImages.forEach(image => {
    if (image.imageUrl) {
      images.push(new AreaOfDamageImage({
        imageUrl: image.imageUrl,
        selectVal: image.selectVal
      }))
    }
  })
  return images
}
